import Vue from 'vue'
import VueXesAlert from './index.vue'
const XesAlertConstructor = Vue.extend(VueXesAlert)
let instance
const xesAlert = options => {
  xesAlert.init()
  instance.title = ''
  instance.onSure = null
  instance.onCancel = null
  instance.sureText = ''
  instance.cancelText = ''
  if (typeof options === 'object') {
    instance.type = options.type ? options.type : instance.type
    instance.onSure = options.onSure
    instance.onCancel = options.onCancel
    instance.sureText = options.sureText ? options.sureText : '确定'
    instance.cancelText = options.cancelText ? options.cancelText : '取消'
    instance.title = options.title ? options.title : instance.title
    instance.message = options.message ? options.message : instance.message
    instance.hasCloseBtn = options.hasCloseBtn
  } else {
    console.log('参数错误')
    return
  }
  instance.show = true
}
xesAlert.init = () => {
  if (!instance) {
    instance = new XesAlertConstructor()
    instance.vm = instance.$mount()
    document.body.appendChild(instance.vm.$el)
  }
}
xesAlert.close = () => {
  if (instance) {
    instance.show = false
  }
}
xesAlert.install = Vue => {
  // console.log('install--------toastMessage')
  Vue.prototype.$xesAlert = xesAlert
}
export default xesAlert
